import React from 'react'
import './css/AboutHero.css'
import Navbar from './Navbar'
import Award from './../assets/images/Award.jpg'
import { Link } from 'react-router-dom'

function AboutHero() {
  return (
    <div className='AboutHero'>
        <div className='overlay'></div>
        <Navbar className='navbar'/>
        <div className='content'>
          <div className='left'>
              <p className='winner'>Award winning&nbsp;<span>catering</span></p>
              <h1>From Intimate<br/> To Extravagant</h1>
              <Link to="/gallery"><button className='cta'>Our Works</button></Link>
          </div>
          <div className='right'>
              <img className='awarding' src={Award} alt='Award' />
          </div>
        </div>
    </div>
  )
}

export default AboutHero